<template>
  <div class="wrapper">
    <div class="container products-header">
      <div class="page-panel-header">
        <span>{{ $t('home.products' /* 数据产品 */) }}</span>
        <img
          class="mark-img"
          src="/images/portal/home/products-mark.svg"
          :alt="$t('home.products' /* 数据产品 */)"
        />
      </div>
      <ul class="page-panel-desc-list">
        <li>{{ $t('home.productDesc1' /* 实时监控企业、市场的发展 */) }}</li>
        <li>{{ $t('home.productDesc2' /* 通过交叉分析，实现精细化的研究 */) }}</li>
        <li>{{ $t('home.productDesc3' /* 快速完成复杂的分析课题 */) }}</li>
        <li>{{ $t('home.productDesc4' /* 快速获取数据，并便捷的处理 */) }}</li>
      </ul>
    </div>
    <div class="products-layout">
      <div class="container">
        <Header
          :icon-path="`${assetsPathBase}/products-header-general.png`"
          :name="parsedData.general && parsedData.general.name"
          :desc="parsedData.general && parsedData.general.desc"
        />
        <layout-general :data="parsedData.general ? parsedData.general.data : []" />
      </div>
    </div>
    <div class="products-layout has-bg">
      <div class="container">
        <Header
          :icon-path="`${assetsPathBase}/products-header-marketing.png`"
          :name="parsedData.marketing && parsedData.marketing.name"
          :desc="parsedData.marketing && parsedData.marketing.desc"
        />
        <layout-marketing :data="parsedData.marketing ? parsedData.marketing.data : []" />
      </div>
    </div>
    <div class="products-layout">
      <div class="container">
        <Header
          :icon-path="`${assetsPathBase}/products-header-products.png`"
          :name="parsedData.products && parsedData.products.name"
          :desc="parsedData.products && parsedData.products.desc"
        />
        <layout-products :data="parsedData.products ? parsedData.products.data : []" />
      </div>
    </div>
    <div class="products-layout has-bg">
      <div class="container">
        <Header
          :icon-path="`${assetsPathBase}/products-header-others.png`"
          :name="$t('home.Other' /* 其他 */)"
        />
        <layout-others :data="parsedData.others" />
      </div>
    </div>
    <iw-dialog
      :title="$t('applyFormProduct')"
      custom-class="apply-to-trial"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div id="applyTrial">
        {{ $t("applyFormComfirm", { product: applyProduct.productName }) }}
      </div>
      <div slot="footer" class="dialog-footer">
        <iw-button @click="dialogVisible = false">{{ $t("cancel") }}</iw-button>
        <iw-button type="primary" @click="doApplyTrial">
          {{ $t("confirm") }}
        </iw-button>
      </div>
    </iw-dialog>
  </div>
</template>

<script>
import Header from "./header.vue";
import LayoutGeneral from "./layout-general.vue";
import LayoutMarketing from "./layout-marketing.vue";
import LayoutProducts from "./layout-products.vue";
import LayoutOthers from "./layout-others.vue";
import { commons } from "./mixin";
import { mapState } from "vuex";
import { tryApply } from "@/api/apps";

export default {
  name: "Products",
  components: {
    Header,
    LayoutGeneral,
    LayoutMarketing,
    LayoutProducts,
    LayoutOthers
  },
  mixins: [commons],
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      applyProduct: {},
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.userInfo
    }),
    parsedData() {
      const results = {};
      this.data.forEach(item => {
        switch (item.groupId) { // item.groupName
          case 3: // "综合看板"
            results.general = {
              id: item.groupId,
              name: item.groupName,
              desc: item.descrip,
              data: item.productList
            };
            break;
          case 4: // "营销"
            results.marketing = {
              id: item.groupId,
              name: item.groupName,
              desc: item.descrip,
              data: item.productList
            };
            break;
          case 5: // "产品"
            results.products = {
              id: item.groupId,
              name: item.groupName,
              desc: item.descrip,
              data: item.productList.filter(
                // 去除“车型检索”产品
                _item => !["车型检索"].includes(_item.productName)
              )
            };
            break;
          default:
            results.others = results.others || [];
            results.others.push({
              id: item.groupId,
              name: item.groupName,
              name_zh_CN: item.groupName_zh_CN,
              desc: item.descrip,
              data: item.productList
            });
        }
      });
      return results;
    }
  },
  methods: {
    doApplyTrial() {
      const { compNm, emalAd, phonNo, userNm } = this.user;
      const { productId, productName } = this.applyProduct;
      this.loading = this.$loading({
        lock: true,
        target: document.querySelector("#applyTrial")
      });
      tryApply({
        compNm,
        emalAd,
        phonNo,
        userNm,
        randomCode: "",
        productList: [
          {
            productId,
            productName
          }
        ]
      })
        .then(response => {
          const { status } = response.data || {};
          this.loading.close();
          this.$message({
            type: status.status === 0 ? "success" : "error",
            message: status.status === 0 ? "申请成功" : "申请失败",
            customClass:
              status.status === 0 ? "message-success" : "message-error"
          });
          if (status.status === 0) {
            this.dialogVisible = false;
          }
        })
        .catch(() => {
          this.loading.close();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/common";
.wrapper {
  @include content-wrapper([container]);
  margin-top: 40px;
  margin-bottom: 80px;
  .products-header {
    margin-bottom: 30px;
    .mark-img {
      display: block;
      width: 87px;
      margin: 16px auto;
    }
  }
  .products-layout {
    @include content-wrapper([container]);
    padding-top: 60px;
    padding-bottom: 60px;
    &.has-bg {
      background: #f6f9ff;
      box-shadow: inset 0 10px 30px rgba(51, 102, 255, 0.06);
    }
  }
}
</style>
